<template>
  <div class="paymentError">
    <div class="payment-img">
      <svg xmlns="http://www.w3.org/2000/svg" width="269" height="169" viewBox="0 0 269 169">
          <g fill="none" fill-rule="evenodd" transform="translate(0 2)">
              <ellipse cx="133.768" cy="163" fill="#EFEAED" fill-rule="nonzero" opacity=".8" rx="47" ry="4"/>
              <path fill="#FF2D55" fill-opacity=".03" d="M189.22 43.192h51.663l-9.253 14h21.59l-21.59 14 9.253 62H189.22z"/>
              <path fill="#FF2D55" fill-opacity=".05" d="M189 47h45.205l-10.097 13.756 20.892-1-19.892 10.755L234.205 129H189z"/>
              <path fill="#FF2D55" fill-opacity=".03" d="M80 43.192H28.337l9.253 14H16l21.59 14-9.253 62H80z"/>
              <path fill="#FF2D55" fill-opacity=".05" d="M79 47H33.795l9.097 12.756H23L42.892 71.51 33.795 129H79z"/>
              <circle cx="232.305" cy="74.203" r="6.328" fill="#FFF" stroke="#A8E4FF" stroke-width="4"/>
              <circle cx="205.328" cy="99.328" r="6.328" fill="#FFF" opacity=".649"/>
              <circle cx="207.785" cy="145.226" r="3.164" fill="#FFF" stroke="#A8E4FF" stroke-width="2"/>
              <circle cx="225.582" cy="145.582" r="1.582" fill="#FFF" stroke="#EE7993" stroke-width="2"/>
              <circle cx="43.582" cy="145.582" r="1.582" fill="#FFF" stroke="#EE7993" stroke-width="2"/>
              <circle cx="60.667" cy="145.226" r="3.164" fill="#FFF" stroke="#A8E4FF" stroke-width="2"/>
              <circle cx="35.356" cy="75.203" r="6.328" fill="#FFF" stroke="#A8E4FF" stroke-width="4"/>
              <circle cx="62.328" cy="99.328" r="6.328" fill="#FFF" opacity=".649"/>
              <g fill="#FFB54C" transform="translate(244.96 117.542)">
                  <rect width="9.492" height="1.582" x="-.791" y="3.164" rx=".791" transform="rotate(45 3.955 3.955)"/>
                  <rect width="9.492" height="1.582" x="-.791" y="3.164" rx=".791" transform="rotate(-45 3.955 3.955)"/>
              </g>
              <g fill="#D8D8D8" transform="rotate(45 4.165 374.4)">
                  <rect width="4.8" height="1" x="-.4" y="1.6" rx=".5" transform="rotate(45 2 2)"/>
                  <rect width="4.8" height="1" x="-.4" y="1.6" rx=".5" transform="rotate(-45 2 2)"/>
              </g>
              <g fill="#D8D8D8" transform="rotate(45 -127.335 56.93)">
                  <rect width="4.8" height="1" x="-.4" y="1.6" rx=".5" transform="rotate(45 2 2)"/>
                  <rect width="4.8" height="1" x="-.4" y="1.6" rx=".5" transform="rotate(-45 2 2)"/>
              </g>
              <g fill="#FFB54C" transform="translate(14.791 117.542)">
                  <rect width="9.492" height="1.582" x="-.791" y="3.164" rx=".791" transform="rotate(45 3.955 3.955)"/>
                  <rect width="9.492" height="1.582" x="-.791" y="3.164" rx=".791" transform="rotate(-45 3.955 3.955)"/>
              </g>
              <path fill="#FAFAFA" stroke="#FF2D55" stroke-width="3" d="M78.893 140h108.85a4 4 0 0 0 3.985-3.641l11.88-132A4 4 0 0 0 199.624 0H68.333a4 4 0 0 0-3.987 4.319l10.56 132A4 4 0 0 0 78.893 140z"/>
              <path fill="#231804" d="M118.901 68.618a2.735 2.735 0 0 1-1.942-.805l-12.875-12.875a2.745 2.745 0 0 1 0-3.883 2.745 2.745 0 0 1 3.884 0l12.875 12.875a2.745 2.745 0 0 1-1.942 4.688"/>
              <path fill="#231804" d="M106.026 68.618a2.745 2.745 0 0 1-1.942-4.688l12.875-12.875a2.745 2.745 0 1 1 3.884 3.883l-12.875 12.875a2.735 2.735 0 0 1-1.942.805M161.973 68.618a2.735 2.735 0 0 1-1.942-.805l-12.874-12.875a2.746 2.746 0 0 1 3.884-3.883l12.874 12.875a2.744 2.744 0 0 1-1.942 4.688"/>
              <path fill="#231804" d="M149.099 68.618a2.744 2.744 0 0 1-1.942-4.688l12.875-12.875a2.745 2.745 0 1 1 3.883 3.883l-12.874 12.875a2.735 2.735 0 0 1-1.942.805M135.748 101.868h-3.495c-5.86 0-10.611-4.751-10.611-10.611v-3.495c0-5.86 4.75-10.611 10.61-10.611h3.496c5.86 0 10.61 4.75 10.61 10.61v3.496c0 5.86-4.75 10.61-10.61 10.61"/>
              <path fill="#F0551F" d="M134 89.052c-5.11 0-9.52 1.685-11.66 5.963 1.518 4.002 5.377 6.853 9.912 6.853h3.496c4.535 0 8.394-2.85 9.913-6.853-2.141-4.278-6.552-5.963-11.661-5.963"/>
          </g>
      </svg>
    </div>
    <h2 class="regular-font title">Payment Failed</h2>
    <p class="small-font description">Sorry we could not process your payment</p>
    <router-link tag="button" class="btn-regular primary" :to="{name: 'transaction'}">Go To Transaction</router-link>
  </div>
</template>

<script>

export default {
  name: 'adx-payment-error',
  components: {

  },
  props: {

  },
  data() {
    return {

    }
  },
  computed: {

  },
  watch: {

  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {

  },
  mounted() {

  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {

  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>